<div class="button-wrapper">
  <div class="button-wrapper-container">
    <div class="button-wrapper-button">
      <div
        class="button-wrapper-mat-button button-wrapper-mat-button-true"
        mat-button
        (click)="clickButtonTrue()"
      >
        <p>Salvar</p>
        <!-- <mat-icon class="" svgIcon=""></mat-icon> -->
      </div>
    </div>
    <div class="button-wrapper-button">
      <div
        class="button-wrapper-mat-button button-wrapper-mat-button-false"
        mat-button
        (click)="clickButtonFalse()"
      >
        <p>Cancelar</p>
        <!-- <mat-icon class="" svgIcon=""></mat-icon> -->
      </div>
    </div>
  </div>
</div>
